import baba from "./p_baba.gif";
import blik from "./p_blik.gif";
import bold from "./p_bold.gif";
import boldno from "./p_boldno.gif";
import bum from "./p_bum.gif";
import buu from "./p_buu.gif";
import fuck from "./p_fuck.gif";
import grr from "./p_grr.gif";
import heh from "./p_heh.gif";
import hul from "./p_hul.gif";
import ital from "./p_ital.gif";
import italno from "./p_italno.gif";
import kenny from "./p_kenny.gif";
import ko from "./p_ko.gif";
import ok from "./p_ok.gif";
import ooo from "./p_ooo.gif";
import ovce from "./p_ovce.gif";
import pict from "./p_pict.gif";
import prdel from "./p_prdel.gif";
import pulitr from "./p_pulitr.gif";
import smich from "./p_smich.gif";
import smrt from "./p_smrt.gif";
import snek from "./p_snek.gif";
import srdce from "./p_srdce.gif";
import under from "./p_under.gif";
import underno from "./p_underno.gif";
import vict from "./p_vict.gif";
import zeme from "./p_zeme.gif";

export const emoticons: {[keys: string]: any} = {
  baba,
  blik,
  bold,
  boldno,
  bum,
  buu,
  fuck,
  grr,
  heh,
  hul,
  ital,
  italno,
  kenny,
  ko,
  ok,
  ooo,
  ovce,
  pict,
  prdel,
  pulitr,
  smich,
  smrt,
  snek,
  srdce,
  under,
  underno,
  vict,
  zeme
};
